import { connect } from 'react-redux';
import { setVATPrice } from 'Favourites/store/actions';
import appStorage from 'helpers/AppStorage';
import { selectProducts } from 'Favourites/store/reducers/data/products';

import {
    selectExcludeVAT,
} from 'store/reducers/data/user';

const getExcludeVatValue = (state) =>
    selectExcludeVAT(state) ??
    (appStorage('excludeVAT') && JSON.parse(appStorage('excludeVAT'))) ??
    window.Checkout.settings.exclude_vat_default;

const mapStateToProps = (state) => {
    return {
        excludeVAT: getExcludeVatValue(state),
        products: selectProducts(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setVAT: (value) => {
            dispatch(setVATPrice(value));
            appStorage('excludeVAT', value);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
